export default __webpack_public_path__ + "12f52101a677e1cf1b468e6306c7b4e0.jpg";